'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import employeeAction from '../../actions/employeeAction';
import employeeStore from '../../stores/employeeStore';

class EmployeeProfile extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            userDetail: employeeStore.getState().userDetail
        };

    }
    static defaultProps = {
        roleTxt: [
            "Administrative Executive", "Property Executive", "Property Manager", "Human Resource Executive",
            "Contracts Management Executive", "Accounts Executive", "Accounts Manager", "Information Technology",
            "Managing Director", "Director", "Other","Cleaner Supervisor","Cleaner","Landscaper","Electrician","Caretaker",
            "Portfolio Manager", "Team Manager","Senior Admin Executive"
        ],
        departmentTxt: [
            "Accounts", "HR", "Operations", "Management", "IT", "Admin", "A4FM"
        ],
        statusTxt: ["Employed", "Resigned", "Dismissed", "Terminated"],
        genderTxt: ["Male", "Female"],
        raceTxt: ["Chinese", "Malay", "Indian", "Other"],
        educationTxt: ["Primary", "N-level", "O-Level", "GCE 'A' Level", "Diploma", "Bachelor", "Master", "Other"]
    };

    componentDidMount() {
        employeeStore.listen(this.onChange);
        if (!this.state.processing) {
            employeeAction.clear();
            employeeAction.processing(true);
            employeeAction.userDetail(this.props.staffId);
        }
    }
    componentWillUnmount() {
        employeeStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({ userDetail: state.userDetail })
    }
    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            window.print();
        } else if (index == 2) {
            employeeAction.displayDetail(false);
        } else {
            if (!this.state.processing) {
                employeeAction.processing(true);
                employeeAction.getEmployeeExport(this.props.staffId);
            }
        }
    }
    renderSupervisor(supervisor) {
        if (!supervisor) return;
        let spvr = supervisor.map((staff, index) => {
            return (
                <li key={index} className="us-item">{staff.userName}</li>
            );
        });

        return (
            <ol>
                {spvr}
            </ol>
        )
    }
    renderPermission(permission) {
        if (!permission) return;
        let pms = permission.map((permission, index) => {
            return (
                <li className="us-pms" key={index}>{permission.title}</li>
            )
        });

        return (
            <ul className="us-ul">
                {pms}
            </ul>
        )
    }
    render() {
        let s = this.state.userDetail;
        return (
            <div className="emp-bd-wp">
                <div className="row">
                    <h3><b>Employee Profile</b></h3>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="userName">Employee Name</label>
                            <div className="us-item">{s.userName}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="staffId">Employee Id</label>
                            <div className="us-item">{s.staffId ? s.staffId : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="identidyType">Identity Type</label>
                            <div className="us-item">{s.identidyType ? s.identidyType : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="identidyNo">Identity Number</label>
                            <div className="us-item">{s.identidyNo ? s.identidyNo : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="gender">Gender</label>
                            <div className="us-item">{s.gender ? this.props.genderTxt[s.gender] : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="dob">D.O.B</label>
                            <div className="us-item">{s.dob ? s.dob : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="race">Race</label>
                            <div className="us-item">{s.race ? this.props.raceTxt[s.race] : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="nation">Nationality</label>
                            <div className="us-item">{s.nationality ? s.nationality : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="education">Level of Education</label>
                            <div className="us-item">{s.education ? this.props.educationTxt[s.education] : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="school">Name of School (Highest Level)</label>
                            <div className="us-item">{s.school ? s.school : "--"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="employmentDate">Employment Date</label>
                            <div className="us-item">{s.employmentDate ? s.employmentDate : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="status">Employment Status</label>
                            <div className="us-item">{this.props.statusTxt[s.status]}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="department">Department</label>
                            <div className="us-item">{s.department ? this.props.departmentTxt[s.department] : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="designation">Designation</label>
                            <div className="us-item">{s.role ? this.props.roleTxt[parseInt(s.role)] : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="officeExtNo">Office Ext No.</label>
                            <div className="us-item">{s.officeExtNo ? s.officeExtNo : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email address</label>
                            <div className="us-item">{s.email ? s.email : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="supervisor">Reporting Manager</label>
                            {this.renderSupervisor(s.supervisor)}
                        </div>
                        <div className="form-group">
                            <label>OT Claim</label>
                            <div className="us-item">{s.otClaim ? "Yes" : "No"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="remark">Remark</label>
                            <div className="us-item">{s.remark ? s.remark : "--"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="ui-pre-w">
                            <img className="ui-pre" src={s.userImage} attribute="staff Picture Preview" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="startWork">Start Work</label>
                            <div className="us-item">{s.startWork ? s.startWork : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="endWork">End Work</label>
                            <div className="us-item">{s.endWork ? s.endWork : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="startLunch">Lunch Time Start</label>
                            <div className="us-item">{s.startLunch ? s.startLunch : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="endLunch">Lunch Time End</label>
                            <div className="us-item">{s.endLunch ? s.endLunch : "--"}</div>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                    <h4><b>Residential Address</b></h4>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="streetName">STREET NAME</label>
                            <div className="us-item">{s.streetName ? s.streetName : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="blkNo">APT/BLK NO.</label>
                            <div className="us-item">{s.blkNo ? s.blkNo : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="unitNo">UNIT NO.</label>
                            <div className="us-item">{s.unitNo ? s.unitNo : "--"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">

                        <div className="form-group">
                            <label htmlFor="postal">POSTAL CODE</label>
                            <div className="us-item">{s.postal ? s.postal : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="homeTel">Home Tel.</label>
                            <div className="us-item">{s.homeTel ? s.homeTel : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="handPhone">HAND PHONE</label>
                            <div className="us-item">{s.handPhone ? s.handPhone : "--"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h4 className="us-em-tt">Emergency Contact</h4>
                        <div className="form-group">
                            <label htmlFor="emgName">NAME</label>
                            <div className="us-item">{s.emgName ? s.emgName : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="emgContactNo">CONTACT NO</label>
                            <div className="us-item">{s.emgContactNo ? s.emgContactNo : "--"}</div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="emgRelationship">RELATIONSHIP</label>
                            <div className="us-item">{s.emgRelationship ? s.emgRelationship : "--"}</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <h4><b>Company Issue</b></h4>

                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comHandphone">HANDPHONE</label>
                            <label>Number</label>
                            <div className="us-un1">{s.comHandphone ? s.comHandphone.number : "N/A"}</div>
                            <label>Model</label>
                            <div className="us-un1">{s.comHandphone ? s.comHandphone.model : "N/A"}</div>
                            <label>Serial</label>
                            <div className="us-un1">{s.comHandphone ? s.comHandphone.serial : "N/A"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comLaptop">Laptop</label>
                            <label>Number</label>
                            <div className="us-un1">{s.comLaptop ? s.comLaptop.number : "N/A"}</div>
                            <label>Model</label>
                            <div className="us-un1">{s.comLaptop ? s.comLaptop.model : "N/A"}</div>
                            <label>Serial</label>
                            <div className="us-un1">{s.comLaptop ? s.comLaptop.serial : "N/A"}</div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="comCabcard">CAB CARD</label>
                            <label>Number</label>
                            <div className="us-un1">{s.comCabcard ? s.comCabcard.number : "N/A"}</div>
                            <label>Model</label>
                            <div className="us-un1">{s.comCabcard ? s.comCabcard.model : "N/A"}</div>
                            <label>Serial</label>
                            <div className="us-un1">{s.comCabcard ? s.comCabcard.serial : "N/A"}</div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="warning">{this.state.warningMsg}</div>
                        <button type="button" className="btn btn-primary us-cr"
                            data-index="0" onClick={this.handleClick}>Print</button>
                        <button type="button" className="btn btn-primary us-cr"
                            data-index="1" onClick={this.handleClick}>Export</button>
                        <button type="button" className="btn btn-default us-cr"
                            data-index="2" onClick={this.handleClick}>Back</button>
                    </div>
                    <div className="clear"></div>
                </div>
            </div>
        );
        /*
        <div className="row emp-pms">
            <h4><b>Permission Granted</b></h4>
            <div className="col-md-12">
                {this.renderPermission(s.permission)}
            </div>
        </div>
        */
    }
}
export default EmployeeProfile;


// WEBPACK FOOTER //
// ./app/components/employeeComponents/employeeProfile.js